import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {
  constructor(private meta: Meta, private titleService: Title) {}

  ngOnInit(): void {
    this.titleService.setTitle('404 - Page Not Found');
    this.meta.updateTag({ name: 'description', content: 'The page you are looking for does not exist.' });
    this.meta.updateTag({ name: 'robots', content: 'noindex, follow' });
  }

}
